module.exports = __webpack_public_path__ + "static/media/cardBG.f7dcfecb.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/cardBG.png
// module id = 1163
// module chunks = 0